/* KidCollective Wishlist System */
/**
 * @typedef {Object} WishlistItem
 * @property {string|number} id
 * @property {string} title
 * @property {string} price
 * @property {string} image
 * @property {string} url
 * @property {string} variantId
 */
(function(){
  const STORAGE_KEY = 'kc_wishlist';

  /** @returns {WishlistItem[]} */
  function getWishlist(){ try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') || []; } catch(e){ return []; } }
  
  /** @param {WishlistItem[]} items */
  function saveWishlist(items){ localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); updateUI(); }

  /** @param {WishlistItem} product */
  function addItem(product){
    const items = getWishlist();
    if(items.find(i => i.id == product.id)) return;
    items.push(product);
    saveWishlist(items);
  }

  /** @param {string|number} productId */
  function removeItem(productId){
    let items = getWishlist();
    items = items.filter(i => i.id != productId);
    saveWishlist(items);
  }

  /** @param {string|number} productId */
  function isInWishlist(productId){ return getWishlist().some(i => i.id == productId); }

  function updateUI(){
    const items = getWishlist();
    const countEls = document.querySelectorAll('.kc-wishlist-count');
    countEls.forEach(el => {
      el.textContent = String(items.length);
      if (el instanceof HTMLElement) {
        el.style.display = items.length > 0 ? 'flex' : 'none';
      }
    });

    // Update heart buttons
    document.querySelectorAll('.kc-wishlist-btn, .kc-wishlist-btn-ui').forEach(btn => {
      if (btn instanceof HTMLElement) {
        const id = btn.dataset.productId;
        if (id) {
          btn.classList.toggle('active', isInWishlist(id));
        }
      }
    });

    // Update drawer
    renderDrawer(items);
  }

  window.kcProductCache = window.kcProductCache || {};

  function formatPriceStr(str) {
      if (!str) return '';
      return str.replace(/INR|IND|Rs\./gi, '₹');
  }

  /** @param {WishlistItem[]} items */
  function renderDrawer(items){
    const container = document.getElementById('kc-wishlist-items');
    const empty = document.getElementById('kc-wishlist-empty');
    if(!container) return;

    if(items.length === 0){
      container.querySelectorAll('.kc-wishlist-item').forEach(el => el.remove());
      if(empty) empty.style.display = '';
      return;
    }

    const missingHandles = items.map(i => {
      let handle = "";
      if (i.url) {
        const parts = i.url.split('?')[0].split('/');
        handle = parts[parts.length - 1];
      }
      return handle;
    }).filter(h => h && !window.kcProductCache[h]);
    
    const uniqueMissing = [...new Set(missingHandles)];

    Promise.all(uniqueMissing.map(h => fetch('/products/' + h + '.js').then(r=>r.json()).then(p => { window.kcProductCache[h] = p; }).catch(e=>console.error(e))))
    .then(() => {
      container.querySelectorAll('.kc-wishlist-item').forEach(el => el.remove());
      if(empty) empty.style.display = 'none';

      items.forEach(item => {
        let handle = "";
        if (item.url) {
          const parts = item.url.split('?')[0].split('/');
          handle = parts[parts.length - 1];
        }

        let priceHtml = '<p class="kc-wishlist-item-price">' + formatPriceStr(item.price) + '</p>';
        const product = window.kcProductCache[handle];
        
        if (product) {
           const variant = product.variants.find(v => v.id == item.variantId) || product.variants[0];
           if (variant && variant.compare_at_price > variant.price) {
               const unitMrp = variant.compare_at_price;
               const linePrice = variant.price;
               const discountPercent = Math.round(((unitMrp - linePrice) / unitMrp) * 100);
               const fmt = (cents) => '₹ ' + (cents/100).toFixed(2);
               
               priceHtml = '<p class="kc-wishlist-item-price" style="display:flex; align-items:center; gap:6px; flex-wrap:wrap;">' +
                 '<span class="kc-wishlist-price-final" style="font-weight:600;">' + fmt(linePrice) + '</span>' +
                 '<s class="kc-wishlist-price-mrp" style="color:#888; font-size:0.85em;">' + fmt(unitMrp) + '</s>' +
                 '<span class="kc-wishlist-price-discount" style="color:var(--kc-primary, #e75480); font-size:0.8em; font-weight:600;">(-' + discountPercent + '%)</span>' +
                 '</p>';
           } else if (variant) {
               const fmt = (cents) => '₹ ' + (cents/100).toFixed(2);
               priceHtml = '<p class="kc-wishlist-item-price">' + fmt(variant.price) + '</p>';
           }
        }

        const div = document.createElement('div');
        div.className = 'kc-wishlist-item';
        div.innerHTML = '<div class="kc-wishlist-item-img"><img src="' + item.image + '" alt="' + item.title + '" width="80" height="100"></div>' +
          '<div class="kc-wishlist-item-info"><p class="kc-wishlist-item-name">' + item.title + '</p>' +
          priceHtml +
          '<div class="kc-wishlist-item-actions">' +
          '<button class="kc-wishlist-item-atc" data-variant-id="' + item.variantId + '">Add to Cart</button>' +
          '<button class="kc-wishlist-item-remove" data-id="' + item.id + '">Remove</button></div></div>';
        container.appendChild(div);

        const removeBtn = div.querySelector('.kc-wishlist-item-remove');
        if (removeBtn instanceof HTMLElement) {
          removeBtn.addEventListener('click', () => removeItem(removeBtn.dataset.id || ''));
        }
        const atcBtn = div.querySelector('.kc-wishlist-item-atc');
        if (atcBtn instanceof HTMLElement) {
          atcBtn.addEventListener('click', () => { 
            // @ts-ignore
            if (typeof kcAddToCart !== 'undefined') kcAddToCart(atcBtn.dataset.variantId, 1, atcBtn); 
          });
        }
      });
    });
  }

  // Create heart particles
  /** @param {HTMLElement} btn */
  function createParticles(btn){
    for(let i = 0; i < 6; i++){
      const p = document.createElement('span');
      p.className = 'kc-heart-particle';
      p.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      p.style.left = btn.offsetLeft + btn.offsetWidth/2 + 'px';
      p.style.top = btn.offsetTop + btn.offsetHeight/2 + 'px';
      const angle = (Math.PI * 2 * i) / 6;
      const dist = 30 + Math.random() * 20;
      p.style.transition = 'all 0.6s ease';
      const closest = btn.closest('.kc-product-card-media, .kc-card-media');
      if (closest) closest.appendChild(p);
      requestAnimationFrame(() => {
        p.style.transform = 'translate(' + Math.cos(angle)*dist + 'px,' + Math.sin(angle)*dist + 'px) scale(0)';
        p.style.opacity = '0';
      });
      setTimeout(() => p.remove(), 700);
    }
  }

  // Click handler for wishlist buttons
  document.addEventListener('click', function(e){
    if (!(e.target instanceof Element)) return;
    const btn = e.target.closest('.kc-wishlist-btn, .kc-wishlist-btn-ui');
    if(!(btn instanceof HTMLElement)) return;
    e.preventDefault();

    const id = btn.dataset.productId;
    if(!id) return;
    if(isInWishlist(id)){
      removeItem(id);
      btn.classList.remove('active');
    } else {
      addItem({
        id: id,
        title: btn.dataset.productTitle || '',
        price: btn.dataset.productPrice || '',
        image: btn.dataset.productImage || '',
        url: btn.dataset.productUrl || '',
        variantId: btn.dataset.variantId || ''
      });
      btn.classList.add('active', 'bounce');
      createParticles(btn);
      setTimeout(() => btn.classList.remove('bounce'), 500);

      // Fly to wishlist animation
      const target = document.getElementById('kc-wishlist-toggle');
      const card = btn.closest('.kc-product-card-ui, .kc-wishlist-item, .kc-product-layout');
      let img = card ? card.querySelector('.kc-gallery-main img, .kc-card-image-item img, img') : null;
      if (img && target) {
        const imgRect = img.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const flyImg = img.cloneNode(true);
        if (!(flyImg instanceof HTMLElement)) return;
        flyImg.style.position = 'fixed';
        flyImg.style.left = imgRect.left + 'px';
        flyImg.style.top = imgRect.top + 'px';
        flyImg.style.width = imgRect.width + 'px';
        flyImg.style.height = imgRect.height + 'px';
        flyImg.style.zIndex = '99999';
        flyImg.style.transition = 'all 0.6s cubic-bezier(0.25, 1, 0.5, 1)';
        flyImg.style.borderRadius = '50%';
        flyImg.style.objectFit = 'cover';
        flyImg.style.opacity = '1';
        flyImg.style.pointerEvents = 'none';
        document.body.appendChild(flyImg);
        
        requestAnimationFrame(() => {
          flyImg.style.left = (targetRect.left + targetRect.width / 2 - 20) + 'px';
          flyImg.style.top = (targetRect.top + targetRect.height / 2 - 20) + 'px';
          flyImg.style.width = '40px';
          flyImg.style.height = '40px';
          flyImg.style.opacity = '0.3';
        });
        
        setTimeout(() => { flyImg.remove(); target.classList.add('kc-shake'); setTimeout(()=>target.classList.remove('kc-shake'),300); }, 600);
      }
    }
  });

  // Drawer toggle
  function openWishlist(){ 
    const drawer = document.getElementById('kc-wishlist-drawer');
    const overlay = document.getElementById('kc-wishlist-overlay');
    if (drawer) drawer.classList.add('open'); 
    if (overlay) overlay.classList.add('open'); 
    document.body.style.overflow='hidden'; 
  }
  function closeWishlist(){ 
    const drawer = document.getElementById('kc-wishlist-drawer');
    const overlay = document.getElementById('kc-wishlist-overlay');
    if (drawer) drawer.classList.remove('open'); 
    if (overlay) overlay.classList.remove('open'); 
    document.body.style.overflow=''; 
  }

  document.getElementById('kc-wishlist-toggle')?.addEventListener('click', openWishlist);
  document.getElementById('kc-wishlist-close')?.addEventListener('click', closeWishlist);
  document.getElementById('kc-wishlist-overlay')?.addEventListener('click', closeWishlist);

  // Init
  updateUI();
  // @ts-ignore
  window.kcWishlist = { add: addItem, remove: removeItem, isIn: isInWishlist, update: updateUI };
})();
